import React from "react";
// import ThreeDProperties from "../Shared/3DProperties";
import StyleProperties from "../Shared/StyleProperties";
import Coordinates from "../Shared/Coordinates";
import Details from "../Shared/Details";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { createOrUpdateShape } from "orion-components/GlobalData/Actions";
import { getTranslation } from "orion-components/i18n";
import MapDisplayOptions from "../Shared/MapDisplayOptions";

const PolygonEditor = () => {
	const { mapTools } = useSelector((state) => state.mapState);

	const dispatch = useDispatch();

	useEffect(() => {
		const { feature } = mapTools;
		if (feature) {
			const { properties } = feature;
			const { polyStroke, polyFill, polyFillOpacity, lineWidth, lineType, lineStrokeOpacity } = properties;
			dispatch(
				createOrUpdateShape("polygon", {
					polyStroke,
					polyFill,
					polyFillOpacity: polyFillOpacity * 100,
					lineWidth,
					lineStrokeOpacity: lineStrokeOpacity * 100,
					lineType
				})
			);
		}
	}, []);

	return (
		<div>
			<Details shapeName={getTranslation("global.sharedComponents.shapeEditor.shapeName")} shapeType="polygon" />
			{/* <ThreeDProperties /> */}
			<MapDisplayOptions shapeType="polygon" />
			<StyleProperties shapeType="polygon" />
			<Coordinates />
		</div>
	);
};
export default PolygonEditor;
